export const DEFAULT_LEADERBOARD_DATA = {
    top: [],
    bottom: [],
    wallet: [],
    search: [],
    all: [],
};
